export const version = 'kunde-v1.20.0-SNAPSHOT-31ec5e6c4bf8903aa763200e42faef342febe62e';